import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Nav, NavItem, NavLink } from "reactstrap";
import "../scss/landing.scss";
import "../scss/darkmodeLanding.scss";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IProjectModel, ThemeTypes } from "../models/SharedModel";
import Service from "../services";
import { ProjectStatus } from "../models/ProjectModel";
import ProjectList from "../components/project/ProjectList";
import NewProjectModal from "../components/project/NewProjectModal";
import LogsModal from "../components/shared/LogsModal";
import WorkSpaceModal from "../components/workspace/WorkSpaceModal";
import { getFromSession, removeFromSession } from "../helpers/GenericHelpers";
import AddWorkSpaceModal from "../components/shared/AddWorkSpaceModal";
import WorkSpaceUserMappingModal from "../components/workspace/WorkSpaceUserMappingModal";
import { toast } from "react-toastify";
import GlobalLoader from "../commonfields/GlobalLoader";
import documentAIService from "../projects/document_ai/documentAIService";
import { ThemeContext } from "../models/ThemeContext";
import { RoutesEnum } from "../models/RoutesModel";

import ibexLightFullIcon from "../images/lightLeftBarIcons/ibexLightFullIcon.png";
import ibexDarkFullIcon from "../images/darkLeftBarIcons/ibexDarkFullIcon.png";

import helpCicle from "../images/darkLeftBarIcons/help-circle.png";
import settings from "../images/darkLeftBarIcons/settings.png";
import logOut from "../images/darkLeftBarIcons/log-out.png";

import helpCicleLight from "../images/lightLeftBarIcons/help-circle.png";
import settingsLight from "../images/lightLeftBarIcons/settings.png";
import logOutLight from "../images/lightLeftBarIcons/log-out.png";

import Profile from "../components/shared/Profile";

import DraftIcon from "../images/darkLeftBarIcons/DraftIcon.png";
import productionIcon from "../images/darkLeftBarIcons/productionIcon.png";
import workspaceIcon from "../images/darkLeftBarIcons/workspaceIcon.png";

import DraftIconChecked from "../images/CheckedIcons/DraftIcon.png";
import productionIconChecked from "../images/CheckedIcons/productionIcon.png";
import workspaceIconChecked from "../images/CheckedIcons/workspaceIcon.png";

import DraftIconLight from "../images/lightLeftBarIcons/DraftIcon.png";
import productionIconLight from "../images/lightLeftBarIcons/productionIcon.png";
import workspaceIconLight from "../images/lightLeftBarIcons/workspaceIcon.png";

import { useNavigate } from "react-router-dom";

const LandingPage = () => {

  const { themeName } = useContext(ThemeContext);

  const images:string[]=
   (themeName === ThemeTypes.DARK_THEME) ?
   [DraftIcon, productionIcon, workspaceIcon, helpCicle, logOut, settings]
   :  [DraftIconLight, productionIconLight, workspaceIconLight, helpCicleLight, logOutLight, settingsLight]

  const checked = [DraftIconChecked, productionIconChecked, workspaceIconChecked];
  const [processingTabs, setProcessingTabs] = useState(
    ProjectStatus.DRAFT
  );
  const service = new Service();
  const documentAIservice = new documentAIService();

  // states
  const [newModal, setNewModal] = useState(false); // modal to create new project
  const [newWorkSpaceModal, setWorkSpaceModal] = useState(false); // modal to create new workspace
  const [loader, setLoader] = useState(false)

  const [mapWorkSpaceAndUserModal, setmapWorkSpaceAndUserModal] = useState(false); // modal to create new project

  const [projectList, setProjectList] = useState<IProjectModel[]>([]); // list of projects
  const [selectedProject, setSelectedProject] = useState<IProjectModel | null>(
    null
  ); // project on dropdown verison create
  const [projectSearch, setProjectSearch] = useState(""); // project search
  const [logsModal, setLogsModal] = useState(false); // modal to get logs
  const [addWorkSpaceModal, setAddWorkSpaceLogsModal] = useState(false); // modal to get logs
  const [selectedWorkSpace, setSelectedWorkSpace] = useState<any>()

  // helpers
  const userName = getFromSession('user_name');
  const navigate = useNavigate();
  const logout = () => {
    removeFromSession('user_name')
    removeFromSession('user_id')
    navigate(`/${RoutesEnum.LOGIN}`)
  }
  // toggle project creation modal
  const toggleNewModal = () =>
    setNewModal((prev) => {
      if (prev) setSelectedProject(null);
      return !prev;
    });

  const toggleWorkSpaceModal = () =>
    setWorkSpaceModal((prev) => {
      // if (prev) setSelectedProject(null);
      return !prev;
    });

  const toggleMapWorkSpaceModal = () => {
    setmapWorkSpaceAndUserModal((prev) => {
      // if (prev) setSelectedProject(null);
      return !prev;
    });
  }

  const toggleLogsModal = () => setLogsModal((prev) => {
    if (prev) setSelectedProject(null);
    return !prev;
  });

  const toggleAddWorkSpaceModal = () => setAddWorkSpaceLogsModal((prev) => {
    // if (prev) setSelectedProject(null);
    return !prev;
  });

  // trigger this project creation is success
  const create_project_api_success = (project: IProjectModel) => {
    get_project_list();
  };

  const handleSearch = (value: string) => {
    setProjectSearch(value);
  };

  // apis
  // api to create the project

  // get the list of the projects
  const get_project_list = () => {
    setLoader(true);
    service
      .get_project_list()
      .then((res) => {
        setProjectList(
          res?.data?.map((each) => ({
            ...each,
            status: ProjectStatus.DRAFT,
            projectId: `${Math.random()}`,
          }))
        )
        setLoader(false);
      }
      )
      .catch((err) => {
        setLoader(false);
        console.log(err)
      });
  };

  // useEffects
  useEffect(() => {
    get_project_list();
  }, []);

  const validProjects = useMemo(
    () => projectList?.filter((each) => each?.project_name?.toLocaleLowerCase()?.includes(projectSearch?.toLocaleLowerCase())),
    [projectList, projectSearch]
  );

  // console.log(validProjects)
  const [workSpaceData, setWorkSpaceData] = useState<any>()
  const user_id = getFromSession('user_id');

  const getWorkSpaces = () => {
    setLoader(true);
    service.get_workspace_details(user_id).then((response: any) => {
      setWorkSpaceData(response?.data);
      setLoader(false);
    }).catch((error: any) => {
      console.log(error)
      setLoader(false);
    })
  }
  useEffect(() => {
    getWorkSpaces()
  }, [])

  const addProjectToWorkSpace = () => {
    const data = {
      workspace_id: selectedWorkSpace?.workspace_id,
      project_id: selectedProject?.project_id
    }
    setLoader(true);
    service.workspace_project_mapping(data).then((response: any) => {
      setLoader(false);
      toast.success(response?.data);
      toggleAddWorkSpaceModal();
      getWorkSpaces()
      const payload = {
        project_id: selectedProject?.project_id,
        project_status: 'workspace'
      }
      documentAIservice.change_project_status(payload).then((res) => {
        console.log(res?.data)
      })
    }).catch((error: any) => {
      toast.success('something went wrong')
      toggleAddWorkSpaceModal()
      setLoader(false);
      console.log(error)
    })
  }
  // This is for left navigation purpose. Itb reflects displayTabs in ProjectList
  const [leftNavigationTab, setLeftNavigationTab] = useState(ProjectStatus.DRAFT)
  const stleftTabs = (value:any) =>{
    setProcessingTabs(value)
    setLeftNavigationTab(value)
  }
  return (
    <>
      {/* {themeName === ThemeTypes?.BLUE_THEME ? */}
        {/* <div className="landing-main">
          {loader ? <GlobalLoader /> : <></>}
          <div className="gen-background"></div>
          <div className="gen-title">
            <div className="new-proj">
              <div className="left">Solutions Dashboard</div>
              <div className="right">
                <div className="search-box">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search"
                    value={projectSearch}
                    onChange={(e) => handleSearch(e?.target?.value)}
                  />
                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                </div>
                <Button onClick={toggleWorkSpaceModal} className="create-project work-space">
                  <FontAwesomeIcon icon={faPlus} /> Create Work Space
                </Button>
                <Button onClick={toggleNewModal} className="create-project">
                  <FontAwesomeIcon icon={faPlus} /> Create New
                </Button>
              </div>
            </div>
          </div>

          <ProjectList
            projectList={validProjects}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            toggleNewModal={toggleNewModal}
            toggleLogsModal={toggleLogsModal}
            toggleAddWorkSpaceModal={toggleAddWorkSpaceModal}
            workSpaceData={workSpaceData}
            setWorkSpaceData={setWorkSpaceData}
            toggleMapWorkSpaceModal={toggleMapWorkSpaceModal}
            setSelectedWorkSpace={setSelectedWorkSpace}
            selectedWorkSpace={selectedWorkSpace}
          />

        </div> : */}
        <>
        <div className='left-menu'>
            <div className='header'>
                <img src={themeName === ThemeTypes?.BLUE_THEME ? ibexLightFullIcon : ibexDarkFullIcon} alt='Ibex'/>
            </div>
            <div className='menu'>
                 <div className='top-menu'>
                 <Nav pills>
                 <div className='item'>
                 <NavItem>
                  <NavLink
                    className={
                      processingTabs === ProjectStatus.DRAFT
                        ? "active"
                        : ""
                    }
                    onClick={() => stleftTabs(ProjectStatus.DRAFT)}
                    // onClick={() => setProcessingTabs(ProjectStatus.DRAFT)}
                    // onClick={() => navigate(`${RoutesEnum.LANDING}`)}
                  >
                    <img src={processingTabs === ProjectStatus.DRAFT ? checked[0] : images[0]} alt="Home"/><div className='text'>Draft </div>
                  </NavLink>
                </NavItem>
                </div>
                <div className='item'>
                {/* <NavItem>
                  <NavLink
                    className={
                      processingTabs === ProjectStatus.PRODUCTION
                        ? "active"
                        : ""
                    }
                    // onClick={() => setProcessingTabs(ProjectStatus.PRODUCTION)}
                    onClick={() => stleftTabs(ProjectStatus.PRODUCTION)}
                  >
                      <img src={processingTabs === ProjectStatus.PRODUCTION ? checked[1] : images[1]} alt="Home"/><div className='text'>Production</div>
                  </NavLink>
                </NavItem> */}
                </div>
                <div className='item'>
                {/* <NavItem>
                  <NavLink
                    className={
                      processingTabs === ProjectStatus.WORK_SPACE
                        ? "active"
                        : ""
                    }
                    // onClick={() => setProcessingTabs(ProjectStatus.WORK_SPACE)}
                    onClick={() => stleftTabs(ProjectStatus.WORK_SPACE)}
                  >
                      <img src={processingTabs === ProjectStatus.WORK_SPACE ? checked[2] : images[2]} alt="Home"/><div className='text'>Workspace</div>
                  </NavLink>
                </NavItem> */}
                </div>
                 </Nav>
                 </div>
                 <div className='footer-menu'>
                    <div className='item'><img src={images[3]} alt="Home"/><div className='text'>Help</div></div>
                    <div className='item'  onClick={() => navigate(`${RoutesEnum.ADMIN_SETTINGS}`)}><img src={images[5]} alt="Home" /><div className='text'>Settings</div></div>
                    <div className='item' onClick={()=>logout()}><img src={images[4]} onClick={()=>logout()} alt="Home"/><div className='text'>Logout</div></div>
                    <div className='item'>
                      {/* <img className='iconImg' src={user} alt="Home"/> */}
                      <Profile />
                    <div className='text'>{userName}</div></div>
                    {/* <Profile /> */}
                 </div>
            </div>
        </div>
        <div className={`${themeName === ThemeTypes?.BLUE_THEME ? 'dark-bright-landing-main' : 'dark-mode-landing-main'}`}>
          <div className="gen-title">
            <div className="new-proj">
              <div className="left">Solutions Dashboard</div>
              <div className="right">
                {/* <Button onClick={toggleWorkSpaceModal} className="create-project work-space">
                  <FontAwesomeIcon icon={faPlus} /> Create Work Space
                </Button> */}
                <Button onClick={toggleNewModal} className="create-project">
                  <FontAwesomeIcon icon={faPlus} /> Create New
                </Button>
                <div className="search-box">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search"
                    value={projectSearch}
                    onChange={(e) => handleSearch(e?.target?.value)}
                  />
                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                </div>
              </div>
            </div>
          </div>
          <ProjectList
            projectList={validProjects}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            toggleNewModal={toggleNewModal}
            toggleLogsModal={toggleLogsModal}
            toggleAddWorkSpaceModal={toggleAddWorkSpaceModal}
            workSpaceData={workSpaceData}
            setWorkSpaceData={setWorkSpaceData}
            toggleMapWorkSpaceModal={toggleMapWorkSpaceModal}
            setSelectedWorkSpace={setSelectedWorkSpace}
            selectedWorkSpace={selectedWorkSpace}
            leftNavigationTab={leftNavigationTab}
            get_project_list={get_project_list}
          />
        </div>
        </>
      
      <>
      <NewProjectModal
            selectedProject={selectedProject}
            projectModal={newModal}
            toggleProjectModal={toggleNewModal}
            apiSuccessCallback={create_project_api_success}
          />

          {/* Change name */}
          <WorkSpaceModal
            workSpaceModal={newWorkSpaceModal}
            toggleWorkSpaceModal={toggleWorkSpaceModal}
            getWorkSpaces={getWorkSpaces}
          />

          <WorkSpaceUserMappingModal
            mapWorkSpaceAndUserModal={mapWorkSpaceAndUserModal}
            toggleMapWorkSpaceModal={toggleMapWorkSpaceModal}
            selectedWorkSpace={selectedWorkSpace}
            getWorkSpaces={getWorkSpaces}
          />

          <LogsModal
            logsModal={logsModal}
            toggleLogsModal={toggleLogsModal}
          />

          {/* Change name */}
          <AddWorkSpaceModal
            selectedProject={selectedProject}
            addWorkSpaceModal={addWorkSpaceModal}
            toggleAddWorkSpaceModal={toggleAddWorkSpaceModal}
            workSpaceData={workSpaceData}
            selectedWorkSpace={selectedWorkSpace}
            setSelectedWorkSpace={setSelectedWorkSpace}
            addProjectToWorkSpace={addProjectToWorkSpace}
          />
      </>
    </>
  );
};

export default LandingPage;
